exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-title[data-v-33ec43fc]{font-weight:600;font-size:20px;color:#fff;text-align:center;font-family:PingFangSC,PingFang SC;padding:10px;word-wrap:break-word}", ""]);

// exports
